<template>
  <div class="col-12 no-pad-both-xs">
    <ul id="list-sort-selector">
      <li @click="sortByName" :class="{active: sortListByName}" role="button" class="tag-tab col-6" aria-label="Sorter liste over steder alfabetisk" tabindex="0">Alfabetisk</li>
      <li @click="sortByDistance" :class="{active: !sortListByName}" role="button" class="tag-tab col-6" aria-label="Sorter liste over steder efter afstand" tabindex="0">Efter afstand</li>
    </ul>

    <div id="position-selector">
      <span id="position-address"></span>
      <br>
      <span role="button" id="change-user-position" class="blue-text" @click="$emit('toggleCustomDistanceOptions');" tabindex="0">Klik her for at sortere listen ud fra en anden position.</span>
      <br>
    </div>

    <table id="tag-list" class="table" aria-label="Liste over temaets steder">
      <tbody>

        <template v-for="feature in listData">
          <TagListFeature :feature="feature" :tagId="tagId" :key="feature.id"></TagListFeature>
        </template>

      </tbody>
    </table>

  </div>
</template>

<script>

import TagListFeature from '@/components/tag/TagListFeature.vue'
import DataManager from '@/assets/DataManager.js'

export default {
  data() {
    return {
      sortListByName: true,
    }
  },
  props: {
    tagData: {
      required: true,
    },
    tagId: {
      type: String,
      required: true
    },
    tagInfo: {
      required: true,
    },
  },
  components: {
    TagListFeature
  },
  watch: {
    tagData() {
      this.sortBySettings();
    },
  },
  computed: {
    //Since data can contain multiple items with the same id, we filter out duplicates for the list
    listData() {
      if(this.tagData != false) {
        var alreadyAdded = [];
        var listData = [];
        for(var i = 0; i < this.tagData.features.length; i++) {
          if(alreadyAdded.indexOf(this.tagData.features[i].id) == -1) {
            alreadyAdded.push(this.tagData.features[i].id);
            listData.push(this.tagData.features[i]);
          }
        }
        console.log(listData);
        return listData;
      }
    }
  },
  methods: {
    sortBySettings() {
      var tagSortBySetting = localStorage.getItem('OdenseRundt-TagSortBy-'+this.tagId);
      if(tagSortBySetting != undefined && tagSortBySetting != null) {
        (tagSortBySetting == 'distance') ? this.sortByDistance() : this.sortByName();
      }
      else if(this.tagInfo.sortBy) {
        (this.tagInfo.sortBy == 'distance') ? this.sortByDistance() : this.sortByName();
      }
    },
    sortByName() {
      if(localStorage.getItem('OdenseRundt-FunctionalCookies') == 'true') {
        localStorage.setItem('OdenseRundt-TagSortBy-'+this.tagId, 'name');
      }

      this.sortListByName = true;
      this.$emit('sortBy', 'name');
    },
    sortByDistance() {
      if(localStorage.getItem('OdenseRundt-FunctionalCookies') == 'true') {
        localStorage.setItem('OdenseRundt-TagSortBy-'+this.tagId, 'distance');
      }
      this.sortListByName = false;
      this.$emit('sortBy', 'distance');
    },
  },
}
</script>

<style lang="scss" scoped>
  #tag-list {
    margin-bottom: 0px;
  }

  .tag-tab {
  	display: inline-block;
  	text-align: center;
    line-height: 48px;
    height: 48px;
    padding: 0;
    margin: 0;
    text-transform: uppercase;
    letter-spacing: .8px;
    cursor: pointer;
  }

  .tag-tab.active {
  	border-bottom: 3px solid rgb(000,112,141);
  	color: rgb(000,112,141);
  }
</style>
